import { Spinner } from '@upright/ui/common/generic/components/spinner';
import { NotAffectingLineHeightObject } from '@upright/ui/common/generic/components/not-affecting-line-height-object';
import { VisuallyHidden } from '@upright/ui/common/generic/components/visually-hidden';
import styles from './Buttons.module.css';
import { type InternalProps } from './Button.types';
import { useContext } from 'react';
import { Focusable, TooltipTriggerStateContext } from 'react-aria-components';
import { FocusRing } from '../focus-ring';

export function ButtonContent({
  startIcon: StartIcon,
  endIcon: EndIcon,
  children,
  variant,
  color,
  isDisabled,
  isPending,
  isContentVisuallyHidden,
}: Pick<
  InternalProps,
  'startIcon' | 'endIcon' | 'children' | 'variant' | 'color' | 'isDisabled' | 'isPending' | 'isContentVisuallyHidden'
>) {
  const tooltip = useContext(TooltipTriggerStateContext);
  return (
    <span className={styles.inner}>
      {StartIcon ? (
        <span aria-hidden="true" className={styles.icon}>
          <NotAffectingLineHeightObject>
            <StartIcon className={styles.svg} />
          </NotAffectingLineHeightObject>
        </span>
      ) : null}
      <div data-content-visually-hidden={isContentVisuallyHidden ? 'true' : undefined} className={styles.content}>
        {children}
      </div>
      {EndIcon ? (
        <span aria-hidden="true" className={styles.icon}>
          <NotAffectingLineHeightObject>
            <EndIcon className={styles.svg} />
          </NotAffectingLineHeightObject>
        </span>
      ) : null}
      <span className={styles.spinner}>
        <Spinner color={variant === 'contained' ? 'white' : color === 'danger' ? 'danger' : 'primary'} />
      </span>
      {(isDisabled || isPending) && tooltip ? (
        <Focusable>
          <FocusRing>
            <span className={styles.info}>
              <VisuallyHidden>Information about disabled button</VisuallyHidden>
            </span>
          </FocusRing>
        </Focusable>
      ) : null}
    </span>
  );
}
